import React, { useMemo } from "react";
import Header from "components/Header";
import styles from "./index.module.scss";
import EvaluateTable from "./components/EvaluateTable";
import useRequest from "../../../utils/useRequest";
import { RouteComponentProps } from "react-router-dom";
import { getExamInfo } from "../../../service/exam";
import EvaluateHeader from "./components/EvaluateHeader";
import _ from "underscore";

interface EvaluateExamProps {
    examId: string;
    batchNo: string;
    courseNo: string;
    courseSeq: string;
}

export default function EvaluateExam({
    match
}: RouteComponentProps<EvaluateExamProps>) {
    const [data] = useRequest(() => getExamInfo(match.params.examId));

    const courseInfo = useMemo(() => {
        if (!data) return undefined;
        const { courseNo, courseSeq } = match.params;
        return _.find(data.courseList, { courseNo, courseSeq });
    }, [match, data]);

    return (
        <div className={styles.root}>
            <Header />

            {data && (
                <div className={styles.main}>
                    <EvaluateHeader title={courseInfo?.courseName || ""} />

                    <EvaluateTable
                        batchNo={match.params.batchNo}
                        examId={match.params.examId}
                        courseNo={match.params.courseNo}
                        courseSeq={match.params.courseSeq}
                    />
                </div>
            )}
        </div>
    );
}
